export default __webpack_public_path__ + "static/media/plain-angular.9bb21e12.png";